export default __webpack_public_path__ + "static/media/liquidSFX.a837c3fb.mp3";